import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Collapse,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useUser } from "../../context/AuthContext";
import GeneralDisclosure21 from "./GeneralDisclosure/GeneralDisclosure21";
import GeneralDisclosure22 from "./GeneralDisclosure/GeneralDisclosure22";
import GeneralDisclosure23 from "./GeneralDisclosure/GeneralDisclosure23";
import GeneralDisclosure24 from "./GeneralDisclosure/GeneralDisclosure24";
import GeneralDisclosure25 from "./GeneralDisclosure/GeneralDisclosure25";
import GeneralDisclosure26 from "./GeneralDisclosure/GeneralDisclosure26";
import GeneralDisclosure27 from "./GeneralDisclosure/GeneralDisclosure27";
import GeneralDisclosure28 from "./GeneralDisclosure/GeneralDisclosure28";
import GeneralDisclosure29 from "./GeneralDisclosure/GeneralDisclosure29";
import GeneralDisclosure210 from "./GeneralDisclosure/GeneralDisclosure210";
import GeneralDisclosure211 from "./GeneralDisclosure/GeneralDisclosure211";
import GeneralDisclosure212 from "./GeneralDisclosure/GeneralDisclosure212";
import GeneralDisclosure213 from "./GeneralDisclosure/GeneralDisclosure213";
import GeneralDisclosure214 from "./GeneralDisclosure/GeneralDisclosure214";
import GeneralDisclosure215 from "./GeneralDisclosure/GeneralDisclosure215";
import GeneralDisclosure216 from "./GeneralDisclosure/GeneralDisclosure216";
import GeneralDisclosure217 from "./GeneralDisclosure/GeneralDisclosure217";
import GeneralDisclosure218 from "./GeneralDisclosure/GeneralDisclosure218";
import GeneralDisclosure219 from "./GeneralDisclosure/GeneralDisclosure219";
import GeneralDisclosure220 from "./GeneralDisclosure/GeneralDisclosure220";
import GeneralDisclosure221 from "./GeneralDisclosure/GeneralDisclosure221";
import GeneralDisclosure222 from "./GeneralDisclosure/GeneralDisclosure222";
import GeneralDisclosure223 from "./GeneralDisclosure/GeneralDisclosure223";
import GeneralDisclosure224 from "./GeneralDisclosure/GeneralDisclosure224";
import GeneralDisclosure225 from "./GeneralDisclosure/GeneralDisclosure225";
import GeneralDisclosure226 from "./GeneralDisclosure/GeneralDisclosure226";
import GeneralDisclosure227 from "./GeneralDisclosure/GeneralDisclosure227";
import GeneralDisclosure228 from "./GeneralDisclosure/GeneralDisclosure228";
import GeneralDisclosure229 from "./GeneralDisclosure/GeneralDisclosure229";
import GeneralDisclosure230 from "./GeneralDisclosure/GeneralDisclosure230";
import GRI201_1 from "./EconomicPerformance/GRI201/GRI201-1";
import GRI201_2 from "./EconomicPerformance/GRI201/GRI201-2";
import GRI201_3 from "./EconomicPerformance/GRI201/GRI201-3";
import GRI201_4 from "./EconomicPerformance/GRI201/GRI201-4";
import GRI202_1 from "./EconomicPerformance/GRI202/GRI202-1";
import GRI202_2 from "./EconomicPerformance/GRI202/GRI202-2";
import GRI203_1 from "./EconomicPerformance/GRI203/GRI203-1";
import GRI203_2 from "./EconomicPerformance/GRI203/GRI203-2";
import GRI204_1 from "./EconomicPerformance/GRI204/GRI204-1";
import GRI205_3 from "./EconomicPerformance/GRI205/GRI205-3";
import GRI205_2 from "./EconomicPerformance/GRI205/GRI205-2";
import GRI205_1 from "./EconomicPerformance/GRI205/GRI205-1";
import GRI206_1 from "./EconomicPerformance/GRI206/GRI206-1";
import GRI207_1 from "./EconomicPerformance/GRI207/GRI207-1";
import GRI207_2 from "./EconomicPerformance/GRI207/GRI207-2";
import GRI207_3 from "./EconomicPerformance/GRI207/GRI207-3";
import GRI207_4 from "./EconomicPerformance/GRI207/GRI207-4";
import GRI301_1 from "./GRI300/GRI301/GRI301-1";
import GRI301_2 from "./GRI300/GRI301/GRI301-2";
import GRI301_3 from "./GRI300/GRI301/GRI301-3";
import GRI302_1 from "./GRI300/GRI302/GRI302-1";
import GRI302_2 from "./GRI300/GRI302/GRI302-2";
import GRI302_3 from "./GRI300/GRI302/GRI302-3";
import GRI302_4 from "./GRI300/GRI302/GRI302-4";
import GRI302_5 from "./GRI300/GRI302/GRI302-5";
import GRI303_1 from "./GRI300/GRI303/GRI303-1";
import GRI303_2 from "./GRI300/GRI303/GRI303-2";
import GRI303_3 from "./GRI300/GRI303/GRI303-3";
import GRI303_4 from "./GRI300/GRI303/GRI303-4";
import GRI303_5 from "./GRI300/GRI303/GRI303-5";
import GRI304_1 from "./GRI300/GRI304/GRI304-1";
import GRI304_2 from "./GRI300/GRI304/GRI304-2";
import GRI304_3 from "./GRI300/GRI304/GRI304-3";
import GRI304_4 from "./GRI300/GRI304/GRI304-4";
import GRI305_6 from "./GRI300/GRI305/GRI305-6";
import GRI305_7 from "./GRI300/GRI305/GRI305-7";
import GRI305_5 from "./GRI300/GRI305/GRI305-5";
import GRI305_1 from "./GRI300/GRI305/GRI305-1";
import GRI305_2 from "./GRI300/GRI305/GRI305-2";
import GRI305_3 from "./GRI300/GRI305/GRI305-3";
import GRI305_4 from "./GRI300/GRI305/GRI305-4";
import GRI306_1 from "./GRI300/GRI306/GRI306-1";
import GRI306_2 from "./GRI300/GRI306/GRI306-2";
import GRI306_3 from "./GRI300/GRI306/GRI306-3";
import GRI306_4 from "./GRI300/GRI306/GRI306-4";
import GRI306_5 from "./GRI300/GRI306/GRI306-5";
import GRI308_1 from "./GRI300/GRI308/GRI308-1";
import GRI308_2 from "./GRI300/GRI308/GRI308-2";
import GRI403_8 from "./GRI400/GRI403/GRI403-8";
import GRI403_9 from "./GRI400/GRI403/GRI403-9";
import GRI403_10 from "./GRI400/GRI403/GRI403-10";
import GRI401_1 from "./GRI400/GRI401/GRI401-1";
import GRI401_2 from "./GRI400/GRI401/GRI401-2";
import GRI401_3 from "./GRI400/GRI401/GRI401-3";
import GRI402 from "./GRI400/GRI402";
import GRI403_1 from "./GRI400/GRI403/GRI403-1";
import GRI403_2 from "./GRI400/GRI403/GRI403-2";
import GRI403_3 from "./GRI400/GRI403/GRI403-3";
import GRI403_4 from "./GRI400/GRI403/GRI403-4";
import GRI403_5 from "./GRI400/GRI403/GRI403-5";
import GRI403_6 from "./GRI400/GRI403/GRI403-6";
import GRI403_7 from "./GRI400/GRI403/GRI403-7";
import GRI404_1 from "./GRI400/GRI404/GRI404-1";
import GRI404_2 from "./GRI400/GRI404/GRI404-2";
import GRI404_3 from "./GRI400/GRI404/GRI404-3";
import GRI405_1 from "./GRI400/GRI405/GRI405-1";
import GRI405_2 from "./GRI400/GRI405/GRI405-2";
import GRI406 from "./GRI400/GRI406";
import GRI407 from "./GRI400/GRI407";
import GRI408 from "./GRI400/GRI408";
import GRI409 from "./GRI400/GRI409";
import GRI410 from "./GRI400/GRI410";
import GRI411 from "./GRI400/GRI411";
import GRI415 from "./GRI400/GRI415";
import GRI418 from "./GRI400/GRI418";
import GRI413_1 from "./GRI400/GRI413/GRI413-1";
import GRI413_2 from "./GRI400/GRI413/GRI413-2";
import GRI414_1 from "./GRI400/GRI414/GRI414-1";
import GRI414_2 from "./GRI400/GRI414/GRI414-2";
import GRI416_1 from "./GRI400/GRI416/GRI416-1";
import GRI416_2 from "./GRI400/GRI416/GRI416-2";
import GRI417_1 from "./GRI400/GRI417/GRI417-1";
import GRI417_2 from "./GRI400/GRI417/GRI417-2";
import GRI417_3 from "./GRI400/GRI417/GRI417-3";
import { downloadReport } from "../../Components/Quetionary/Review/downloadReport";
import MainDashboardLayout from "../../Layout/MainDashboardLayout";
import Unauthorized from "../../Components/Unauthorized/Unauthorized";
import GRISidebar from "../../Layout/GRISidebar";
import GriGroup from "./GriGroup";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import styles from "../../styles/gri/general.module.css";

const GRIDownload = () => {
  const pdfRef = useRef();
  const { user } = useUser();
  const [isGenerating, setIsGenerating] = useState(false);
  const { id } = useParams();

  // State for view management
  const [currentView, setCurrentView] = useState("review"); // 'review', 'selection', 'download'

  // State for expanded sections
  const [expandedSections, setExpandedSections] = useState({
    generalDisclosure: false,
    series200: false,
    series300: false,
    series400: false,
  });
  const isAnySelected = (pages) => Object.values(pages).some(Boolean);
  // State for section selection
  const [selectedPages, setSelectedPages] = useState({
    generalDisclosure: {
      all: false,
      pages: {
        general21: false,
        general22: false,
        general23: false,
        general24: false,
        general25: false,
        general26: false,
        general27: false,
        general28: false,
        general29: false,
        general210: false,
        general211: false,
        general212: false,
        general213: false,
        general214: false,
        general215: false,
        general216: false,
        general217: false,
        general218: false,
        general219: false,
        general220: false,
        general221: false,
        general222: false,
        general223: false,
        general224: false,
        general225: false,

        general226: false,
        general227: false,
        general228: false,
        general229: false,
        general230: false,
      },
    },
    series200: {
      all: false,
      pages: {
        gri201: {
          all: false,
          pages: {
            gri201_1: false,
            gri201_2: false,
            gri201_3: false,
            gri201_4: false,
          },
        },
        gri202: {
          all: false,
          pages: {
            gri202_1: false,
            gri202_2: false,
          },
        },
        gri203: {
          all: false,
          pages: {
            gri203_1: false,
            gri203_2: false,
          },
        },

        gri204: {
          all: false,
          pages: {
            gri204_1: false,
          },
        },
        gri205: {
          all: false,
          pages: {
            gri205_1: false,
            gri205_2: false,
            gri205_3: false,
          },
        },

        gri206: {
          all: false,
          pages: {
            gri206_1: false,
          },
        },
        gri207: {
          all: false,
          pages: {
            gri207_1: false,
            gri207_2: false,
            gri207_3: false,
            gri207_4: false,
          },
        },
      },
    },

    series300: {
      all: false,
      pages: {
        gri301: {
          all: false,
          pages: {
            gri301_1: false,
            gri301_2: false,
            gri301_3: false,
          },
        },
        gri302: {
          all: false,
          pages: {
            gri302_1: false,
            gri302_2: false,
            gri302_3: false,
            gri302_4: false,
            gri302_5: false,
          },
        },
        gri303: {
          all: false,
          pages: {
            gri303_1: false,
            gri303_2: false,
            gri303_3: false,
            gri303_4: false,
            gri303_5: false,
          },
        },
        gri304: {
          all: false,
          pages: {
            gri304_1: false,
            gri304_2: false,
            gri304_3: false,
            gri304_4: false,
          },
        },
        gri305: {
          all: false,
          pages: {
            gri305_1: false,
            gri305_2: false,
            gri305_3: false,
            gri305_4: false,
            gri305_5: false,
            gri305_6: false,
            gri305_7: false,
          },
        },
        gri306: {
          all: false,
          pages: {
            gri306_1: false,
            gri306_2: false,
            gri306_3: false,
            gri306_4: false,
            gri306_5: false,
          },
        },
        gri308: {
          all: false,
          pages: {
            gri308_1: false,
            gri308_2: false,
          },
        },
      },
    },
    series400: {
      all: false,
      pages: {
        gri401: {
          all: false,
          pages: {
            gri401_1: false,
            gri401_2: false,
            gri401_3: false,
          },
        },
        gri402: {
          all: false,
          pages: {
            gri402: false,
          },
        },
        gri403: {
          all: false,
          pages: {
            gri403_1: false,
            gri403_2: false,
            gri403_3: false,
            gri403_4: false,
            gri403_5: false,
            gri403_6: false,
            gri403_7: false,
            gri403_8: false,
            gri403_9: false,
            gri403_10: false,
          },
        },
        gri404: {
          all: false,
          pages: {
            gri404_1: false,
            gri404_2: false,
            gri404_3: false,
          },
        },
        gri405: {
          all: false,
          pages: {
            gri405_1: false,
            gri405_2: false,
          },
        },
        gri413: {
          all: false,
          pages: {
            gri413_1: false,
            gri413_2: false,
          },
        },
        gri414: {
          all: false,
          pages: {
            gri414_1: false,
            gri414_2: false,
          },
        },
        gri416: {
          all: false,
          pages: {
            gri416_1: false,
            gri416_2: false,
          },
        },
        gri417: {
          all: false,
          pages: {
            gri417_1: false,
            gri417_2: false,
            gri417_3: false,
          },
        },
        // gri406: false,
        // gri407: false,
        // gri408: false,
        // gri409: false,
        // gri410: false,
        // gri411: false,
        // gri415: false,
        // gri418: false,
        gri406: {
          all: false,
          pages: {
            gri406: false,
          },
        },
        gri407: {
          all: false,
          pages: {
            gri407: false,
          },
        },
        gri408: {
          all: false,
          pages: {
            gri408: false,
          },
        },
        gri409: {
          all: false,
          pages: {
            gri409: false,
          },
        },
        gri410: {
          all: false,
          pages: {
            gri410: false,
          },
        },
        gri411: {
          all: false,
          pages: {
            gri411: false,
          },
        },
        gri415: {
          all: false,
          pages: {
            gri415: false,
          },
        },
        gri418: {
          all: false,
          pages: {
            gri418: false,
          },
        },
      },
    },
  });

  const generalDisclosurePages = Array.from(
    { length: 30 },
    (_, i) => `general2${i + 1}`
  );

  const formatGeneralDisclosure = (pageKey) => {
    const num = pageKey.replace("general", ""); // e.g., "21"
    return `${num[0]}-${num.slice(1)}`; // e.g., "2-1"
  };

  const toggleSectionExpand = (section) => {
    setExpandedSections({
      ...expandedSections,
      [section]: !expandedSections[section],
    });
  };

  const handleParentCheckboxChange = (section) => (e) => {
    const isChecked = e.target.checked;

    // Recursively walk the pages tree
    const toggleTree = (node) => {
      if (typeof node === "boolean") return isChecked; // leaf
      if (node && typeof node === "object") {
        const out = {};
        Object.entries(node).forEach(([k, v]) => {
          if (k === "all") {
            out[k] = isChecked;
          } else {
            out[k] = toggleTree(v);
          }
        });
        return out;
      }
      return node;
    };

    setSelectedPages((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        all: isChecked,
        pages: toggleTree(prev[section].pages),
      },
    }));
  };

  const handleChildCheckboxChange = (section, page) => (e) => {
    const isChecked = e.target.checked;

    // Update the specific page
    const updatedPages = {
      ...selectedPages[section].pages,
      [page]: isChecked,
    };

    // Check if all child checkboxes are selected
    // const allChecked = Object.values(updatedPages).every((val) => val);
    const anyChecked = Object.values(updatedPages).some((val) => val);
    setSelectedPages({
      ...selectedPages,
      [section]: {
        all: anyChecked,
        pages: updatedPages,
      },
    });
  };

  const handleDownload = async () => {
    setIsGenerating(true);
    try {
      await downloadReport(
        pdfRef,
        "GRI_REPORT.pdf",
        "GRI REPORT",
        "https://upload.wikimedia.org/wikipedia/commons/7/70/Example.png"
      );
    } catch (error) {
      console.error("PDF generation failed:", error);
      alert("Failed to generate PDF. Please check console for details.");
    } finally {
      setIsGenerating(false);
    }
  };

  // View navigation handlers
  const goToSelection = () => setCurrentView("selection");
  const goToDownload = () => setCurrentView("download");
  const goBackToReview = () => setCurrentView("review");

  // ... DottedLineBetweenSteps and PageBreak components remain the same ...

  // Add handlers for nested checkboxes

  const handleNestedParentCheckboxChange = (section, subsection) => (e) => {
    const isChecked = e.target.checked;

    const pageKeys = Object.keys(
      selectedPages[section].pages[subsection].pages
    );

    const updatedPages = pageKeys.reduce((acc, page) => {
      acc[page] = isChecked;
      return acc;
    }, {});

    const updatedGroups = {
      ...selectedPages[section].pages,
      [subsection]: {
        all: isChecked,
        pages: updatedPages,
      },
    };

    // ✅ Update the top-level section based on all pages
    const isAnyPageCheckedInSection = Object.values(updatedGroups).some(
      (group) => Object.values(group.pages).some(Boolean)
    );

    setSelectedPages({
      ...selectedPages,
      [section]: {
        all: isAnyPageCheckedInSection,
        pages: updatedGroups,
      },
    });
  };

  const handleNestedChildCheckboxChange =
    (section, subsection, page) => (e) => {
      const isChecked = e.target.checked;

      const currentGroup = selectedPages[section].pages[subsection];
      const updatedPages = {
        ...currentGroup.pages,
        [page]: isChecked,
      };

      const isAnyPageCheckedInSubsection =
        Object.values(updatedPages).some(Boolean);

      const updatedSubsection = {
        ...currentGroup,
        all: isAnyPageCheckedInSubsection,
        pages: updatedPages,
      };

      const updatedGroups = {
        ...selectedPages[section].pages,
        [subsection]: updatedSubsection,
      };

      // ✅ Recalculate top-level series "all" checkbox (e.g., 200 Series)
      const isAnyPageCheckedInSection = Object.values(updatedGroups).some(
        (group) => Object.values(group.pages).some(Boolean)
      );

      setSelectedPages({
        ...selectedPages,
        [section]: {
          all: isAnyPageCheckedInSection,
          pages: updatedGroups,
        },
      });
    };

  const griStructure = {
    series200: {
      label: "200 Series",
      groups: {
        gri201: {
          label: "GRI 201",
          pages: ["gri201_1", "gri201_2", "gri201_3", "gri201_4"],
        },
        gri202: {
          label: "GRI 202",
          pages: ["gri202_1", "gri202_2"],
        },
        gri203: {
          label: "GRI 203",
          pages: ["gri203_1", "gri203_2"],
        },
        gri204: {
          label: "GRI 204",
          pages: ["gri204_1"],
        },
        gri205: {
          label: "GRI 205",
          pages: ["gri205_1", "gri205_2", "gri205_3"],
        },
        gri206: {
          label: "GRI 206",
          pages: ["gri206_1"],
        },
        gri418: {
          label: "GRI 418",
          pages: ["gri418"],
        },
        gri207: {
          label: "GRI 207",
          pages: ["gri207_1", "gri207_2", "gri207_3", "gri207_4"],
        },
      },
    },
  };

  const griStructure300 = {
    series300: {
      label: "300 Series",
      groups: {
        gri301: {
          label: "GRI 301",
          pages: ["gri301_1", "gri301_2", "gri301_3"],
        },
        gri302: {
          label: "GRI 302",
          pages: ["gri302_1", "gri302_2", "gri302_3", "gri302_4", "gri302_5"],
        },
        gri303: {
          label: "GRI 303",
          pages: ["gri303_1", "gri303_2", "gri303_3", "gri303_4", "gri303_5"],
        },
        gri304: {
          label: "GRI 304 ",
          pages: ["gri304_1", "gri304_2", "gri304_3", "gri304_4"],
        },
        gri305: {
          label: "GRI 305 ",
          pages: [
            "gri305_1",
            "gri305_2",
            "gri305_3",
            "gri305_4",
            "gri305_5",
            "gri305_6",
            "gri305_7",
          ],
        },
        gri306: {
          label: "GRI 306 ",
          pages: ["gri306_1", "gri306_2", "gri306_3", "gri306_4", "gri306_5"],
        },
        gri308: {
          label: "GRI 308 ",
          pages: ["gri308_1", "gri308_2"],
        },
      },
    },
  };

  const griStructure400 = {
    series400: {
      label: "400 Series",
      groups: {
        gri401: {
          label: "GRI 401",
          pages: ["gri401_1", "gri401_2", "gri401_3"],
        },
        gri402: {
          label: "GRI 402",
          pages: ["gri402"],
        },
        gri403: {
          label: "GRI 403",
          pages: [
            "gri403_1",
            "gri403_2",
            "gri403_3",
            "gri403_4",
            "gri403_5",
            "gri403_6",
            "gri403_7",
            "gri403_8",
            "gri403_9",
            "gri403_10",
          ],
        },
        gri404: {
          label: "GRI 404",
          pages: ["gri404_1", "gri404_2", "gri404_3"],
        },
        gri405: {
          label: "GRI 405 ",
          pages: ["gri405_1", "gri405_2"],
        },
        gri406: {
          label: "GRI 406",
          pages: ["gri406"],
        },
        gri407: {
          label: "GRI 407",
          pages: ["gri407"],
        },
        gri408: {
          label: "GRI 408",
          pages: ["gri408"],
        },
        gri409: {
          label: "GRI 409",
          pages: ["gri409"],
        },
        gri410: {
          label: "GRI 410",
          pages: ["gri410"],
        },
        gri411: {
          label: "GRI 411",
          pages: ["gri411"],
        },
        gri413: {
          label: "GRI 413 ",
          pages: ["gri413_1", "gri413_2"],
        },
        gri414: {
          label: "GRI 414 ",
          pages: ["gri414_1", "gri414_2"],
        },
        gri415: {
          label: "GRI 415",
          pages: ["gri415"],
        },
        gri416: {
          label: "GRI 416 ",
          pages: ["gri416_1", "gri416_2"],
        },
        gri417: {
          label: "GRI 417 ",
          pages: ["gri417_1", "gri417_2", "gri417_3"],
        },
        gri418: {
          label: "GRI 418",
          pages: ["gri418"],
        },
      },
    },
  };

  return (
    <MainDashboardLayout sidebar={<GRISidebar />}>
      <Unauthorized requiredModule="ESG Reporting |GRI"></Unauthorized>

      {/* REVIEW VIEW */}
      {currentView === "review" && (
        <Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h4" sx={{ my: 2, fontWeight: "bold" }}>
              GRI REPORT
            </Typography>
            <Button
              onClick={goToSelection}
              sx={{
                bgcolor: "#1C486B",
                textTransform: "none",
                height: "3rem",
                mt: 2,
                color: "white",
                "&:hover": { bgcolor: "#0D3A5A" },
                "&:disabled": { bgcolor: "#1C486B80" },
              }}
              variant="contained"
            >
              {/* Customize PDF */}
              Download PDF
            </Button>
          </Box>

          {/* Full report preview */}
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              margin: "0 auto",
              display: "flex",
              flexDirection: "column",
              gap: "2rem",
              pb: "2rem",
            }}
          >
            <GeneralDisclosure21 hide={true} />
            <GeneralDisclosure22 hide={true} />
            <GeneralDisclosure23 hide={true} />
            <GeneralDisclosure24 hide={true} />
            <GeneralDisclosure25 hide={true} />
            <GeneralDisclosure26 hide={true} />
            <GeneralDisclosure27 hide={true} />
            <GeneralDisclosure28 hide={true} />
            <GeneralDisclosure29 hide={true} />
            <GeneralDisclosure210 hide={true} />
            <GeneralDisclosure211 hide={true} />
            <GeneralDisclosure212 hide={true} />
            <GeneralDisclosure213 hide={true} />
            <GeneralDisclosure214 hide={true} />
            <GeneralDisclosure215 hide={true} />
            <GeneralDisclosure216 hide={true} />
            <GeneralDisclosure217 hide={true} />
            <GeneralDisclosure218 hide={true} />
            <GeneralDisclosure219 hide={true} />
            <GeneralDisclosure220 hide={true} />
            <GeneralDisclosure221 hide={true} />
            <GeneralDisclosure222 hide={true} />
            <GeneralDisclosure223 hide={true} />
            <GeneralDisclosure224 hide={true} />
            <GeneralDisclosure225 hide={true} />
            <GeneralDisclosure226 hide={true} />
            <GeneralDisclosure227 hide={true} />
            <GeneralDisclosure228 hide={true} />
            <GeneralDisclosure229 hide={true} />
            <GeneralDisclosure230 hide={true} />

            {/* 200 Series */}
            {/* <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              201 : Economic Performance
            </p>
            <GRI201_1 hide={true} />
            <GRI201_2 hide={true} />
            <GRI201_3 hide={true} />
            <GRI201_4 hide={true} />
            <PageBreak />
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              202 : Market Presence 2016
            </p>
            <GRI202_1 hide={true} />
            <GRI202_2 hide={true} />
            <PageBreak />
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              203 : Indirect Economic Impact
            </p>
            <GRI203_1 hide={true} />
            <GRI203_2 hide={true} />
            <PageBreak />
            <GRI204_1 hide={true} />
            <PageBreak />
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              205 : Anti-corruption 2016
            </p>
            <GRI205_1 hide={true} />
            <GRI205_2 hide={true} />
            <GRI205_3 hide={true} />
            <PageBreak />
            <GRI206_1 hide={true} />
            <PageBreak />
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              207 : Tax 2019
            </p>
            <GRI207_1 hide={true} />
            <GRI207_2 hide={true} />
            <GRI207_3 hide={true} />
            <GRI207_4 hide={true} /> */}

            {/* 300 series */}
            {/* <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              301 : Material Used
            </p>
            <GRI301_1 hide={true} />
            <GRI301_2 hide={true} />
            <GRI301_3 hide={true} />
            <PageBreak />
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              302 : ENERGY
            </p>
            <GRI302_1 hide={true} />
            <GRI302_2 hide={true} />
            <GRI302_3 hide={true} />
            <GRI302_4 hide={true} />
            <GRI302_5 hide={true} />
            <PageBreak />
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              303 : Water & Effluents
            </p>
            <GRI303_1 hide={true} />
            <GRI303_2 hide={true} />
            <GRI303_3 hide={true} />
            <GRI303_4 hide={true} />
            <GRI303_5 hide={true} />
            <PageBreak />
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              304 : Biodiversity
            </p>
            <GRI304_1 hide={true} />
            <GRI304_2 hide={true} />
            <GRI304_3 hide={true} />
            <GRI304_4 hide={true} />
            <PageBreak />
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              305 : Emissions{" "}
            </p>

            <GRI305_1 hide={true} />
            <GRI305_2 hide={true} />
            <GRI305_3 hide={true} />
            <GRI305_4 hide={true} />
            <GRI305_5 hide={true} />
            <GRI305_6 hide={true} />
            <GRI305_7 hide={true} />
           
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              306 : Waste
            </p>
            <GRI306_1 hide={true} />
            <GRI306_2 hide={true} />
            <GRI306_3 hide={true} />
            <GRI306_4 hide={true} />
            <GRI306_5 hide={true} />
            <PageBreak />
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              308 : Supplier Env
            </p>
            <GRI308_1 hide={true} />
            <GRI308_2 hide={true} /> */}

            {/* 400 Series */}
            {/* <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              401 : Material Used
            </p>
            <GRI401_1 hide={true} />
            <GRI401_2 hide={true} />
            <GRI401_3 hide={true} />
            <PageBreak />
            <GRI402 hide={true} />
            <PageBreak />
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              403 : Occupational Health and Safety
            </p>
            <GRI403_1 hide={true} />
            <GRI403_2 hide={true} />
            <GRI403_3 hide={true} />
            <GRI403_4 hide={true} />
            <GRI403_5 hide={true} />
            <GRI403_6 hide={true} />
            <GRI403_7 hide={true} />
            <GRI403_8 hide={true} />
            <GRI403_9 hide={true} />
            <GRI403_10 hide={true} />

            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              404 : Training and Education
            </p>
            <GRI404_1 hide={true} />
            <GRI404_2 hide={true} />
            <GRI404_3 hide={true} />
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              405 : Diversity and Equal Opportunity
            </p>
            <GRI405_1 hide={true} />
            <GRI405_2 hide={true} />
            <GRI406 hide={true} />
            <GRI407 hide={true} />
            <GRI408 hide={true} />
            <GRI409 hide={true} />
            <GRI410 hide={true} />
            <GRI411 hide={true} />

            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              413 : Local Communities
            </p>
            <GRI413_1 hide={true} />
            <GRI413_2 hide={true} />
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              414 : Supplier Social Assessment
            </p>
            <GRI414_1 hide={true} />
            <GRI414_2 hide={true} />

            <GRI415 hide={true} />
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              416 : Customer Health & Safety
            </p>
            <GRI416_1 hide={true} />
            <GRI416_2 hide={true} />
            <p
              className={styles.section_heading}
              style={{ marginBottom: "-1rem" }}
            >
              417 : Marketing & Labelling
            </p>
            <GRI417_1 hide={true} />
            <GRI417_2 hide={true} />
            <GRI417_3 hide={true} />

            <GRI418 hide={true} /> */}
          </Box>
        </Box>
      )}

      {/* SELECTION VIEW */}
      {currentView === "selection" && (
        <Box>
          <Typography variant="h4" sx={{ my: 2, fontWeight: "bold" }}>
            Select Sections for GRI Report
          </Typography>

          <Box
            sx={{ mb: 3, p: 3, border: "1px solid #ddd", borderRadius: "4px" }}
          >
            <FormGroup>
              {/* General Disclosure Section */}
              <Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedPages.generalDisclosure.all}
                        onChange={handleParentCheckboxChange(
                          "generalDisclosure"
                        )}
                        sx={{
                          "&.Mui-checked": {
                            color: "#1c486b",
                          },
                        }}
                      />
                    }
                    label="General Disclosure 2021"
                  />
                  <Button
                    onClick={() => toggleSectionExpand("generalDisclosure")}
                    size="small"
                    sx={{ marginLeft: "-1rem" }}
                  >
                    {/* {expandedSections.generalDisclosure ? "Hide" : "Show"} */}
                    <ExpandCircleDownIcon
                      style={{
                        transform: expandedSections.generalDisclosure
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                        transition: "transform 0.3s ease",
                        color: "#666666",
                      }}
                    />
                  </Button>
                </Box>
                <Collapse in={expandedSections.generalDisclosure}>
                  <Box sx={{ ml: 4, display: "flex", flexDirection: "column" }}>
                    {generalDisclosurePages.map((pageKey) => (
                      <FormControlLabel
                        key={pageKey}
                        control={
                          <Checkbox
                            checked={
                              selectedPages.generalDisclosure.pages[pageKey] ||
                              false
                            }
                            onChange={handleChildCheckboxChange(
                              "generalDisclosure",
                              pageKey
                            )}
                            sx={{
                              "&.Mui-checked": {
                                color: "#1c486b",
                              },
                            }}
                          />
                        }
                        // label={`General Disclosure ${pageKey.replace(
                        //   "general",
                        //   ""
                        // )}`}
                        label={`General Disclosure ${formatGeneralDisclosure(
                          pageKey
                        )}`}
                      />
                    ))}
                  </Box>
                </Collapse>
              </Box>

              {/* 200 Series Section */}
              <Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedPages.series200.all}
                        onChange={handleParentCheckboxChange("series200")}
                        sx={{
                          "&.Mui-checked": {
                            color: "#1c486b",
                          },
                        }}
                      />
                    }
                    label={griStructure.series200.label}
                  />
                  <Button
                    onClick={() => toggleSectionExpand("series200")}
                    size="small"
                    sx={{ marginLeft: "-1rem" }}
                  >
                    {/* {expandedSections.series200 ? "Hide" : "Show"} */}
                    <ExpandCircleDownIcon
                      style={{
                        transform: expandedSections.series200
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                        transition: "transform 0.3s ease",
                        color: "#666666",
                      }}
                    />
                  </Button>
                </Box>

                <Collapse in={expandedSections.series200}>
                  <Box sx={{ ml: 4 }}>
                    {Object.entries(griStructure.series200.groups).map(
                      ([groupKey, groupData]) => (
                        <GriGroup
                          key={groupKey}
                          seriesKey="series200"
                          groupKey={groupKey}
                          groupData={groupData}
                          selectedPages={selectedPages}
                          expandedSections={expandedSections}
                          toggleSectionExpand={toggleSectionExpand}
                          handleNestedParentCheckboxChange={
                            handleNestedParentCheckboxChange
                          }
                          handleNestedChildCheckboxChange={
                            handleNestedChildCheckboxChange
                          }
                        />
                      )
                    )}
                  </Box>
                </Collapse>
              </Box>

              {/* 300 Series Section */}
              <Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedPages.series300.all}
                        onChange={handleParentCheckboxChange("series300")}
                        sx={{
                          "&.Mui-checked": {
                            color: "#1c486b",
                          },
                        }}
                      />
                    }
                    label="300 Series "
                  />
                  <Button
                    onClick={() => toggleSectionExpand("series300")}
                    size="small"
                    sx={{ marginLeft: "-1rem" }}
                  >
                    {/* {expandedSections.series300 ? "Hide" : "Show"} */}
                    <ExpandCircleDownIcon
                      style={{
                        transform: expandedSections.series300
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                        transition: "transform 0.3s ease",
                        color: "#666666",
                      }}
                    />
                  </Button>
                </Box>
                <Collapse in={expandedSections.series300}>
                  <Box sx={{ ml: 4 }}>
                    {Object.entries(griStructure300.series300.groups).map(
                      ([groupKey, groupData]) => (
                        <GriGroup
                          key={groupKey}
                          seriesKey="series300"
                          groupKey={groupKey}
                          groupData={groupData}
                          selectedPages={selectedPages}
                          expandedSections={expandedSections}
                          toggleSectionExpand={toggleSectionExpand}
                          handleNestedParentCheckboxChange={
                            handleNestedParentCheckboxChange
                          }
                          handleNestedChildCheckboxChange={
                            handleNestedChildCheckboxChange
                          }
                        />
                      )
                    )}
                  </Box>
                </Collapse>
              </Box>

              {/* 400 Series Section */}
              <Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedPages.series400.all}
                        onChange={handleParentCheckboxChange("series400")}
                        sx={{
                          "&.Mui-checked": {
                            color: "#1c486b",
                          },
                        }}
                      />
                    }
                    label="400 Series "
                  />
                  <Button
                    onClick={() => toggleSectionExpand("series400")}
                    size="small"
                    sx={{ marginLeft: "-1rem" }}
                  >
                    <ExpandCircleDownIcon
                      style={{
                        transform: expandedSections.series400
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                        transition: "transform 0.3s ease",
                        color: "#666666",
                      }}
                    />
                  </Button>
                </Box>
                <Collapse in={expandedSections.series400}>
                  <Box sx={{ ml: 4 }}>
                    {Object.entries(griStructure400.series400.groups).map(
                      ([groupKey, groupData]) => (
                        <GriGroup
                          key={groupKey}
                          seriesKey="series400"
                          groupKey={groupKey}
                          groupData={groupData}
                          selectedPages={selectedPages}
                          expandedSections={expandedSections}
                          toggleSectionExpand={toggleSectionExpand}
                          handleNestedParentCheckboxChange={
                            handleNestedParentCheckboxChange
                          }
                          handleNestedChildCheckboxChange={
                            handleNestedChildCheckboxChange
                          }
                        />
                      )
                    )}
                  </Box>
                </Collapse>
              </Box>
            </FormGroup>
          </Box>

          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              onClick={goBackToReview}
              sx={{
                bgcolor: "#6b6b6b",
                textTransform: "none",
                height: "3rem",
                color: "white",
                "&:hover": { bgcolor: "#5a5a5a" },
              }}
              variant="contained"
            >
              Back to Review
            </Button>

            <Button
              onClick={goToDownload}
              sx={{
                bgcolor: "#1C486B",
                textTransform: "none",
                height: "3rem",
                color: "white",
                "&:hover": { bgcolor: "#0D3A5A" },
              }}
              variant="contained"
            >
              Preview & Download
            </Button>
          </Box>
        </Box>
      )}

      {/* DOWNLOAD VIEW */}
      {currentView === "download" && (
        <Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Typography variant="h4" sx={{ my: 2, fontWeight: "bold" }}>
              GRI Report Preview
            </Typography>

            <Box>
              <Button
                onClick={() => setCurrentView("selection")}
                sx={{
                  mr: 2,
                  mt: 2,
                  bgcolor: "#6b6b6b",
                  textTransform: "none",
                  height: "3rem",
                  color: "white",
                  "&:hover": { bgcolor: "#5a5a5a" },
                }}
                variant="contained"
              >
                Modify Selection
              </Button>

              <Button
                disabled={isGenerating}
                onClick={handleDownload}
                sx={{
                  bgcolor: "#1C486B",
                  textTransform: "none",
                  height: "3rem",
                  mt: 2,
                  color: "white",
                  "&:hover": { bgcolor: "#0D3A5A" },
                  "&:disabled": { bgcolor: "#1C486B80" },
                }}
                variant="contained"
              >
                {isGenerating ? "Generating PDF..." : "Download PDF"}
              </Button>
            </Box>
          </Box>

          {/* PDF CONTENT */}
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              margin: "0 auto",
              display: "flex",
              flexDirection: "column",
              gap: "2rem",
              pb: "2rem",
            }}
            ref={pdfRef}
          >
            {/* General Disclosure Sections */}
            {selectedPages.generalDisclosure.pages.general21 && (
              <GeneralDisclosure21 hide={true} />
            )}
            <PageBreak />
            {selectedPages.generalDisclosure.pages.general22 && (
              <GeneralDisclosure22 hide={true} />
            )}
            <PageBreak />
            {selectedPages.generalDisclosure.pages.general23 && (
              <GeneralDisclosure23 hide={true} />
            )}
            <PageBreak />
            {selectedPages.generalDisclosure.pages.general24 && (
              <GeneralDisclosure24 hide={true} />
            )}
            <PageBreak />
            {selectedPages.generalDisclosure.pages.general25 && (
              <GeneralDisclosure25 hide={true} />
            )}
            <PageBreak />
            {selectedPages.generalDisclosure.pages.general26 && (
              <GeneralDisclosure26 hide={true} />
            )}
            {selectedPages.generalDisclosure.pages.general27 && (
              <GeneralDisclosure27 hide={true} />
            )}
            {selectedPages.generalDisclosure.pages.general28 && (
              <GeneralDisclosure28 hide={true} />
            )}
            {selectedPages.generalDisclosure.pages.general29 && (
              <GeneralDisclosure29 hide={true} />
            )}
            {selectedPages.generalDisclosure.pages.general210 && (
              <GeneralDisclosure210 hide={true} />
            )}
            {selectedPages.generalDisclosure.pages.general211 && (
              <GeneralDisclosure211 hide={true} />
            )}{" "}
            {selectedPages.generalDisclosure.pages.general212 && (
              <GeneralDisclosure212 hide={true} />
            )}
            {selectedPages.generalDisclosure.pages.general213 && (
              <GeneralDisclosure213 hide={true} />
            )}
            {selectedPages.generalDisclosure.pages.general214 && (
              <GeneralDisclosure214 hide={true} />
            )}{" "}
            {selectedPages.generalDisclosure.pages.general215 && (
              <GeneralDisclosure215 hide={true} />
            )}{" "}
            {selectedPages.generalDisclosure.pages.general216 && (
              <GeneralDisclosure216 hide={true} />
            )}{" "}
            {selectedPages.generalDisclosure.pages.general217 && (
              <GeneralDisclosure217 hide={true} />
            )}{" "}
            {selectedPages.generalDisclosure.pages.general218 && (
              <GeneralDisclosure218 hide={true} />
            )}{" "}
            {selectedPages.generalDisclosure.pages.general219 && (
              <GeneralDisclosure219 hide={true} />
            )}{" "}
            {selectedPages.generalDisclosure.pages.general220 && (
              <GeneralDisclosure220 hide={true} />
            )}{" "}
            {selectedPages.generalDisclosure.pages.general221 && (
              <GeneralDisclosure221 hide={true} />
            )}{" "}
            {selectedPages.generalDisclosure.pages.general222 && (
              <GeneralDisclosure222 hide={true} />
            )}{" "}
            {selectedPages.generalDisclosure.pages.general223 && (
              <GeneralDisclosure223 hide={true} />
            )}{" "}
            {selectedPages.generalDisclosure.pages.general224 && (
              <GeneralDisclosure224 hide={true} />
            )}{" "}
            {selectedPages.generalDisclosure.pages.general225 && (
              <GeneralDisclosure225 hide={true} />
            )}{" "}
            {selectedPages.generalDisclosure.pages.general226 && (
              <GeneralDisclosure226 hide={true} />
            )}
            {selectedPages.generalDisclosure.pages.general227 && (
              <GeneralDisclosure227 hide={true} />
            )}
            {selectedPages.generalDisclosure.pages.general228 && (
              <GeneralDisclosure228 hide={true} />
            )}
            {selectedPages.generalDisclosure.pages.general229 && (
              <GeneralDisclosure229 hide={true} />
            )}
            {selectedPages.generalDisclosure.pages.general230 && (
              <GeneralDisclosure230 hide={true} />
            )}
            {/* 200 Series Sections */}
            {isAnySelected(selectedPages.series200.pages.gri201.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  201 : Economic Performance
                </p>
                {selectedPages.series200.pages.gri201.pages.gri201_1 && (
                  <GRI201_1 hide={true} />
                )}
                {selectedPages.series200.pages.gri201.pages.gri201_2 && (
                  <GRI201_2 hide={true} />
                )}
                {selectedPages.series200.pages.gri201.pages.gri201_3 && (
                  <GRI201_3 hide={true} />
                )}
                {selectedPages.series200.pages.gri201.pages.gri201_4 && (
                  <GRI201_4 hide={true} />
                )}
              </>
            )}
            {isAnySelected(selectedPages.series200.pages.gri202.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  202 : Market Presence 2016
                </p>
                {selectedPages.series200.pages.gri202.pages.gri202_1 && (
                  <GRI202_1 hide={true} />
                )}
                {selectedPages.series200.pages.gri202.pages.gri202_2 && (
                  <GRI202_2 hide={true} />
                )}
              </>
            )}
            {isAnySelected(selectedPages.series200.pages.gri203.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  203 : Indirect Economic Impact
                </p>
                {selectedPages.series200.pages.gri203.pages.gri203_1 && (
                  <GRI203_1 hide={true} />
                )}
                {selectedPages.series200.pages.gri203.pages.gri203_2 && (
                  <GRI203_2 hide={true} />
                )}
              </>
            )}
            {isAnySelected(selectedPages.series200.pages.gri205.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  205 : Anti-corruption 2016
                </p>
                {selectedPages.series200.pages.gri205.pages.gri205_1 && (
                  <GRI205_1 hide={true} />
                )}
                {selectedPages.series200.pages.gri205.pages.gri205_2 && (
                  <GRI205_2 hide={true} />
                )}

                {selectedPages.series200.pages.gri205.pages.gri205_3 && (
                  <GRI205_3 hide={true} />
                )}
              </>
            )}
            {selectedPages.series200.pages.gri204.pages.gri204_1 && (
              <GRI204_1 hide={true} />
            )}
            {selectedPages.series200.pages.gri206.pages.gri206_1 && (
              <GRI206_1 hide={true} />
            )}
            {isAnySelected(selectedPages.series200.pages.gri207.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  207 : Tax 2019
                </p>
                {selectedPages.series200.pages.gri207.pages.gri207_1 && (
                  <GRI207_1 hide={true} />
                )}
                {selectedPages.series200.pages.gri207.pages.gri207_2 && (
                  <GRI207_2 hide={true} />
                )}
                {selectedPages.series200.pages.gri207.pages.gri207_3 && (
                  <GRI207_3 hide={true} />
                )}
                {selectedPages.series200.pages.gri207.pages.gri207_4 && (
                  <GRI207_4 hide={true} />
                )}
              </>
            )}
            {/* 300 Series Sections */}
            {isAnySelected(selectedPages.series300.pages.gri301.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  301 : Material Used
                </p>
                {selectedPages.series300.pages.gri301.pages.gri301_1 && (
                  <GRI301_1 hide={true} />
                )}
                {selectedPages.series300.pages.gri301.pages.gri301_2 && (
                  <GRI301_2 hide={true} />
                )}
                {selectedPages.series300.pages.gri301.pages.gri301_3 && (
                  <GRI301_3 hide={true} />
                )}
              </>
            )}
            {isAnySelected(selectedPages.series300.pages.gri302.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  302 : ENERGY
                </p>
                {selectedPages.series300.pages.gri302.pages.gri302_1 && (
                  <GRI302_1 hide={true} />
                )}
                {selectedPages.series300.pages.gri302.pages.gri302_2 && (
                  <GRI302_2 hide={true} />
                )}
                {selectedPages.series300.pages.gri302.pages.gri302_3 && (
                  <GRI302_3 hide={true} />
                )}
                {selectedPages.series300.pages.gri302.pages.gri302_4 && (
                  <GRI302_4 hide={true} />
                )}
                {selectedPages.series300.pages.gri302.pages.gri302_5 && (
                  <GRI302_5 hide={true} />
                )}
              </>
            )}
            {isAnySelected(selectedPages.series300.pages.gri303.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  303 : Water & Effluents
                </p>
                {selectedPages.series300.pages.gri303.pages.gri303_1 && (
                  <GRI303_1 hide={true} />
                )}
                {selectedPages.series300.pages.gri303.pages.gri303_2 && (
                  <GRI303_2 hide={true} />
                )}
                {selectedPages.series300.pages.gri303.pages.gri303_3 && (
                  <GRI303_3 hide={true} />
                )}
                {selectedPages.series300.pages.gri303.pages.gri303_4 && (
                  <GRI303_4 hide={true} />
                )}
                {selectedPages.series300.pages.gri303.pages.gri303_5 && (
                  <GRI303_5 hide={true} />
                )}
              </>
            )}
            {isAnySelected(selectedPages.series300.pages.gri304.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  304 : Biodiversity
                </p>
                {selectedPages.series300.pages.gri304.pages.gri304_1 && (
                  <GRI304_1 hide={true} />
                )}
                {selectedPages.series300.pages.gri304.pages.gri304_2 && (
                  <GRI304_2 hide={true} />
                )}
                {selectedPages.series300.pages.gri304.pages.gri304_3 && (
                  <GRI304_3 hide={true} />
                )}
                {selectedPages.series300.pages.gri304.pages.gri304_4 && (
                  <GRI304_4 hide={true} />
                )}
              </>
            )}
            {isAnySelected(selectedPages.series300.pages.gri305.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  305 : Emissions
                </p>
                {selectedPages.series300.pages.gri305.pages.gri305_1 && (
                  <GRI305_1 hide={true} />
                )}
                {selectedPages.series300.pages.gri305.pages.gri305_2 && (
                  <GRI305_2 hide={true} />
                )}
                {selectedPages.series300.pages.gri305.pages.gri305_3 && (
                  <GRI305_3 hide={true} />
                )}
                {selectedPages.series300.pages.gri305.pages.gri305_4 && (
                  <GRI305_4 hide={true} />
                )}
                {selectedPages.series300.pages.gri305.pages.gri305_5 && (
                  <GRI305_5 hide={true} />
                )}
                {selectedPages.series300.pages.gri305.pages.gri305_6 && (
                  <GRI305_6 hide={true} />
                )}
                {selectedPages.series300.pages.gri305.pages.gri305_7 && (
                  <GRI305_7 hide={true} />
                )}
              </>
            )}
            {isAnySelected(selectedPages.series300.pages.gri306.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  306 : Waste
                </p>
                {selectedPages.series300.pages.gri306.pages.gri306_1 && (
                  <GRI306_1 hide={true} />
                )}
                {selectedPages.series300.pages.gri306.pages.gri306_2 && (
                  <GRI306_2 hide={true} />
                )}
                {selectedPages.series300.pages.gri306.pages.gri306_3 && (
                  <GRI306_3 hide={true} />
                )}
                {selectedPages.series300.pages.gri306.pages.gri306_4 && (
                  <GRI306_4 hide={true} />
                )}
                {selectedPages.series300.pages.gri306.pages.gri306_5 && (
                  <GRI306_5 hide={true} />
                )}
              </>
            )}
            {isAnySelected(selectedPages.series300.pages.gri308.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  308 : Supplier Env
                </p>
                {selectedPages.series300.pages.gri308.pages.gri308_1 && (
                  <GRI308_1 hide={true} />
                )}
                {selectedPages.series300.pages.gri308.pages.gri308_2 && (
                  <GRI308_2 hide={true} />
                )}
              </>
            )}
            {/* 400 Series Sections */}
            {isAnySelected(selectedPages.series400.pages.gri401.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  401 : Material Used
                </p>
                {selectedPages.series400.pages.gri401.pages.gri401_1 && (
                  <GRI401_1 hide={true} />
                )}
                {selectedPages.series400.pages.gri401.pages.gri401_2 && (
                  <GRI401_2 hide={true} />
                )}
                {selectedPages.series400.pages.gri401.pages.gri401_3 && (
                  <GRI401_3 hide={true} />
                )}
              </>
            )}
            {selectedPages.series400.pages.gri402.pages.gri402 && (
              <GRI402 hide={true} />
            )}
            {isAnySelected(selectedPages.series400.pages.gri403.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  403 : Occupational Health and Safety
                </p>

                {selectedPages.series400.pages.gri403.pages.gri403_1 && (
                  <GRI403_1 hide={true} />
                )}
                {selectedPages.series400.pages.gri403.pages.gri403_2 && (
                  <GRI403_2 hide={true} />
                )}
                {selectedPages.series400.pages.gri403.pages.gri403_3 && (
                  <GRI403_3 hide={true} />
                )}
                {selectedPages.series400.pages.gri403.pages.gri403_4 && (
                  <GRI403_4 hide={true} />
                )}
                {selectedPages.series400.pages.gri403.pages.gri403_5 && (
                  <GRI403_5 hide={true} />
                )}
                {selectedPages.series400.pages.gri403.pages.gri403_6 && (
                  <GRI403_6 hide={true} />
                )}
                {selectedPages.series400.pages.gri403.pages.gri403_7 && (
                  <GRI403_7 hide={true} />
                )}
                {selectedPages.series400.pages.gri403.pages.gri403_8 && (
                  <GRI403_8 hide={true} />
                )}
                {selectedPages.series400.pages.gri403.pages.gri403_9 && (
                  <GRI403_9 hide={true} />
                )}
                {selectedPages.series400.pages.gri403.pages.gri403_10 && (
                  <GRI403_10 hide={true} />
                )}
              </>
            )}
            {isAnySelected(selectedPages.series400.pages.gri404.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  404 : Training and Education
                </p>
                {selectedPages.series400.pages.gri404.pages.gri404_1 && (
                  <GRI404_1 hide={true} />
                )}
                {selectedPages.series400.pages.gri404.pages.gri404_2 && (
                  <GRI404_2 hide={true} />
                )}
                {selectedPages.series400.pages.gri404.pages.gri404_3 && (
                  <GRI404_3 hide={true} />
                )}
              </>
            )}
            {isAnySelected(selectedPages.series400.pages.gri405.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  405 : Diversity and Equal Opportunity
                </p>
                {selectedPages.series400.pages.gri405.pages.gri405_1 && (
                  <GRI405_1 hide={true} />
                )}
                {selectedPages.series400.pages.gri405.pages.gri405_2 && (
                  <GRI405_2 hide={true} />
                )}
              </>
            )}
            {selectedPages.series400.pages.gri406.pages.gri406 && (
              <GRI406 hide={true} />
            )}
            {selectedPages.series400.pages.gri407.pages.gri407 && (
              <GRI407 hide={true} />
            )}
            {selectedPages.series400.pages.gri408.pages.gri408 && (
              <GRI408 hide={true} />
            )}
            {selectedPages.series400.pages.gri409.pages.gri409 && (
              <GRI409 hide={true} />
            )}
            {selectedPages.series400.pages.gri410.pages.gri410 && (
              <GRI410 hide={true} />
            )}
            {selectedPages.series400.pages.gri411.pages.gri411 && (
              <GRI411 hide={true} />
            )}
            {isAnySelected(selectedPages.series400.pages.gri413.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  413 : Local Communities
                </p>
                {selectedPages.series400.pages.gri413.pages.gri413_1 && (
                  <GRI413_1 hide={true} />
                )}
                {selectedPages.series400.pages.gri413.pages.gri413_2 && (
                  <GRI413_2 hide={true} />
                )}
              </>
            )}
            {isAnySelected(selectedPages.series400.pages.gri414.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  414 : Supplier Social Assessment
                </p>
                {selectedPages.series400.pages.gri414.pages.gri414_1 && (
                  <GRI414_1 hide={true} />
                )}
                {selectedPages.series400.pages.gri414.pages.gri414_2 && (
                  <GRI414_2 hide={true} />
                )}
              </>
            )}
            {selectedPages.series400.pages.gri415.pages.gri415 && (
              <GRI415 hide={true} />
            )}
            {isAnySelected(selectedPages.series400.pages.gri416.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  416 : Customer Health & Safety
                </p>
                {selectedPages.series400.pages.gri416.pages.gri416_1 && (
                  <GRI416_1 hide={true} />
                )}
                {selectedPages.series400.pages.gri416.pages.gri416_2 && (
                  <GRI416_2 hide={true} />
                )}
              </>
            )}
            {isAnySelected(selectedPages.series400.pages.gri417.pages) && (
              <>
                <p
                  className={styles.section_heading}
                  style={{ marginBottom: "-1rem" }}
                >
                  417 : Marketing & Labelling
                </p>
                {selectedPages.series400.pages.gri417.pages.gri417_1 && (
                  <GRI417_1 hide={true} />
                )}
                {selectedPages.series400.pages.gri417.pages.gri417_2 && (
                  <GRI417_2 hide={true} />
                )}
                {selectedPages.series400.pages.gri417.pages.gri417_3 && (
                  <GRI417_3 hide={true} />
                )}
              </>
            )}
            {selectedPages.series400.pages.gri418.pages.gri418 && (
              <GRI418 hide={true} />
            )}
          </Box>
        </Box>
      )}

      {/* Global styles remain the same */}
      <style>
        {`
          @media print {
            body, .pdf-content {
              width: 900px !important;
              margin: 0 auto !important;
            }
            table {
              width: 100% !important;
              page-break-inside: avoid !important;
            }
            tr, td {
              page-break-inside: avoid !important;
            }
            .section-break {
              page-break-before: always !important;
            }
            .avoid-break {
              page-break-inside: avoid !important;
            }
          }
        `}
      </style>
    </MainDashboardLayout>
  );
};

// DottedLineBetweenSteps component
const DottedLineBetweenSteps = () => (
  <div
    className="avoid-break"
    style={{
      width: "100%",
      height: "3px",
      background:
        "repeating-linear-gradient(to right, #B3B3B3, #B3B3B3 10px, transparent 5px, transparent 15px)",
    }}
  />
);

// PageBreak component
const PageBreak = () => (
  <div style={{ pageBreakBefore: "always", breakBefore: "page" }} />
);

export default GRIDownload;
